export default __webpack_public_path__ + "static/media/E.3cd1be12.svg";